import React from 'react'
import { tableReportData, tabSelected } from '../@signals'
import { AppReportSearchesModal } from '@components'
import { GLOBAL_EXECUTION_TABS } from '../@constants'


export default function GlobalReportsSearchesModal() {

	return <AppReportSearchesModal data={tableReportData.value} isExtras={tabSelected.value === GLOBAL_EXECUTION_TABS.EXTRAS} />
}